const locale = {
    messages: {
        datanasc: 'Data de nacimento incorreta.',
        idadecompat: 'A data de nascimento não é compatível com o plano selecionado.',
        required: 'O campo deve ser preenchido.',
    },
    custom: {
      	cadastro_de_cartao_social__numero: {
            required: 'O número do cartão social deve ser preenchida.'
    	},
      	cadastro_de_cartao_social__nome: {
            required: 'O nome do beneficiário deve ser preenchida.'
    	},
        datanascimento: {
            datanasc: 'A data de nascimento está incorreta.',
            required: 'A data deve ser preenchida.',
			idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },
        nome: {
        	alpha_spaces: 'O valor inserido é inválido.'
        },
        sobrenome: {
        	alpha_spaces: 'O valor inserido é inválido.'
        },
        email: {
            email: 'Informe um endereço de e-mail válido.',
            email_or_nif: 'E-mail ou NIF é inválido.'
        },
        cpf: {
        	required: 'O NIF deve ser preenchido.',
        	nif: 'NIF inválido, tente novamente!'
        },
        celular: {
            required: 'O campo telemóvel é obrigatório.',
        	min: 'O valor inserido deve conter no mínimo 9 caracteres.'
        },
        sexo: {
        	required: 'Informe o sexo.'
        },
        password: {
        	min: 'O valor inserido deve conter no mínimo 6 caracteres.',
        	confirmed: 'As senhas informadas são diferentes.'
        },
        termoscontrato: {
        	required: 'Você deve aceitar os termos do contrato para avançar.',
        },
        cep: {
        	required: 'Informe seu código postal.',
        },
        estado: {
        	required: 'Selecione seu distrito.',
        },
        cidade: {
        	required: 'Selecione sua localidade.',
        },
        endereco: {
        	required: 'O campo morada é obrigatório.',
        },
        temDependentes:{
        	required: 'Selecione uma opção',
        	included: 'Opção inválida'
		},
		valorlivre:{
        	minimum_price: 'Valor livre incompatível.'
        },
    }
};

export default locale;
